<template>
  <v-card class="planeacion-produccion-card" elevation="0">
    <v-tabs
      v-model="activeTab"
      background-color="transparent"
      color="primary"
      grow
      show-arrows
    >
      <v-tab>
        Plan de Produccion
      </v-tab>
      <v-tab>
        Cumplimiento del Plan de Produccion
      </v-tab>
    </v-tabs>

    <v-divider />

    <v-tabs-items v-model="activeTab" class="planeacion-produccion-tabs">
      <v-tab-item>
        <div class="planeacion-produccion-pane">
          <PlanProduccion ref="planProduccion" />
        </div>
      </v-tab-item>

      <v-tab-item>
        <div class="planeacion-produccion-pane">
          <ReporteCumplimiento />
        </div>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import PlanProduccion from "./PlanProduccion.vue";
import ReporteCumplimiento from "./ReporteCumplimiento.vue";

export default {
  name: "PlaneacionyProduccion",
  components: {
    PlanProduccion,
    ReporteCumplimiento,
  },
  data() {
    return {
      activeTab: 0,
    };
  },
  methods: {
    init() {
      if (this.$refs.planProduccion && typeof this.$refs.planProduccion.init === "function") {
        this.$refs.planProduccion.init();
      }
    },
  },
};
</script>

<style scoped>
.planeacion-produccion-card {
  border: 1px solid #e0e6ef;
  border-radius: 6px;
  background: #fff;
  overflow: hidden;
}

.planeacion-produccion-tabs {
  background: #fff;
}

.planeacion-produccion-pane {
  padding: 12px;
}
</style>
